import './navBar.scss';
import { useEffect } from 'react';
import SvgIcon from 'components/commons/icons/SvgIcon';
import ModalInfoSuccess from 'components/commons/modal/modalnfoSuccess/ModalInfoSuccess';
import ModalSignIn from 'components/features/setting/modalSignIn/ModalSignIn';
import { useLanguage, useTranslate, useSetLanguage } from 'context/languageContext';
import { useTheme } from 'context/themeContext';
import UseLoginOut from 'hooks/useLoginOut/UseLoginOut';
import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routesState } from 'redux/slices/routesSlice';
import { updateShowSubMenu, updateSubMenuIndex } from 'redux/slices/subMenuSlices';
import { updateShowLoading } from 'redux/slices/contextualSlice';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LogoNavbar } from 'resources/icons/Logo_largo.svg';
import { useLazyGetRoutesQuery } from 'redux/services/routesService';
import LanguagePresenter from 'hooks/LanguagePresenter';
import { useDispatch } from 'react-redux';
import { updateRoutes } from 'redux/slices/routesSlice';
import Dropdown from 'components/commons/dropdowns/Dropdown';
import { resetSegments } from 'redux/slices/plannerSegmentsSlice';
import { useSearchParams } from 'react-router-dom';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';
import UseSEO from 'hooks/useSEO/UseSEO';

const NavBar = memo(function NavBar() {
  const location = useLocation();
  const CURRENT_ROUTE = `/${location.pathname.split('/')[2]}`;
  const MENU_TYPE = 1;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [generateUrl, generateTitleAndMeta, navigateStaticPage] = UseSEO();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ searchParams ] = useSearchParams();
  const PAGE_ID = searchParams.get('pageId');
  const FAQ_ID = searchParams.get('faqId');
  const EVENT_ID = searchParams.get('eventId');
  const FAQ_CATEGORY_ID = searchParams.get('faqCategoryId');
  const [GetRoutes] = useLazyGetRoutesQuery();
  const currentLanguage = useLanguage();
  const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginOut, setLoginOut] = useState(false);
  const [logout] = UseLoginOut();
  const t = useTranslate();
  const theme = useTheme();
  const routesSelector = useSelector(routesState);
  const setLanguage = useSetLanguage();
  const { languageOptions } = LanguagePresenter();

  const extraerUrls = (items: any) => {
    return items.flatMap((item: any) => {
      let resultados: any = [];
      if (item.pageId !== null && item.url !== null) {
        resultados.push({ pageId: item.pageId, url: item.url });
      }
      if (item.child && item.child.length > 0) {
        resultados = resultados.concat(extraerUrls(item.child));
      }
      return resultados;
    });
  };

  // Función principal para recorrer todos los niveles del array original
  const obtenerUrlsValidas = (data) => {
    return data.flatMap((subArray) => extraerUrls(subArray));
  };

  const handleStaticPageChange = (pagId, url ,curLang, newLang) => {
    const isPath = Object.values(RUTAS_GENERALES_MUL2)?.find((ruta)=> ruta[curLang] && ruta[curLang] === `${url}/`);
    const curPath = isPath ? isPath[newLang]: '/emt';
    return navigateStaticPage(pagId, false, `/${curPath || '/emt'}`, newLang);
  };

  const handleLangChange = async (lang) => {
    if (currentLanguage === lang) return;
    const ROUTES = Object.values(RUTAS_GENERALES_MUL2);
    const curRoute = location.pathname.slice(4);
    const curBasicRoute = location.pathname.slice(4).split('/');
    const paths = location.pathname.split('/');

    const beforeRoutes = obtenerUrlsValidas(
      routesSelector.map((el) => {
        return el.child;
      }),
    );

    if (beforeRoutes?.length > 0) {
      const lastURL = '/' + paths.slice(2).join('/');
      const finded = beforeRoutes.find((el) => el.url === lastURL);
      if (finded) {
        getNavBarData(lang, finded.pageId);
        setSelectedLanguage(lang);
        setLanguage(lang);
        return;
      }
    }
    setSelectedLanguage(lang);
    setLanguage(lang);
    dispatch(updateShowLoading(true));
    let index = 0;
    let route;
    if (curBasicRoute.length > 1) {
      route = curBasicRoute.join('/');
    } else {
      route = curBasicRoute[0];
    }

    for (let i = 0; i < ROUTES.length; i++) {
      if (
        ROUTES[i][currentLanguage] === curRoute ||
        ROUTES[i][currentLanguage] === `${curRoute}/` ||
        (curBasicRoute.length > 0 && ROUTES[i][currentLanguage] === `${route}/`)
      ) {
        index = i;
        break;
      }
    }

    if(PAGE_ID) return handleStaticPageChange(PAGE_ID, curBasicRoute[0], currentLanguage, lang );
    if(curRoute === RUTAS_GENERALES_MUL2.eventDetail[currentLanguage] && EVENT_ID) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.eventDetail[lang]}?eventId=${EVENT_ID}`);
    if(`${location.pathname.split('/')[2]}/` === RUTAS_GENERALES_MUL2.emtNewDetail[currentLanguage]) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.emtNewDetail[lang]}${curBasicRoute[1]}/${curBasicRoute[2]}`);
    if(`${location.pathname.split('/')[2]}/` === RUTAS_GENERALES_MUL2.lines[currentLanguage] && paths?.length > 5) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.lines[lang]}${curBasicRoute[1]}/${curBasicRoute[2]}/${curBasicRoute[3]}/${curBasicRoute[4]}/${curBasicRoute[5]}/${curBasicRoute[6]}`);
    if(`${location.pathname.split('/')[2]}/` === RUTAS_GENERALES_MUL2.paradas[currentLanguage] && paths?.length > 4) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.paradas[lang]}${curBasicRoute[1]}/${curBasicRoute[2]}`);
    if(`${location.pathname.split('/')[2]}/` === RUTAS_GENERALES_MUL2.notices[currentLanguage] && curBasicRoute?.length === 2) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.notices[lang]}${curBasicRoute[1]}`);
    if(FAQ_ID && FAQ_CATEGORY_ID) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.atclientFaqCategory[lang]}?faqCategoryId=${FAQ_CATEGORY_ID}&faqId=${FAQ_ID}`);
    if(FAQ_CATEGORY_ID) return navigate(`/${lang}/${RUTAS_GENERALES_MUL2.atclientFaqCategory[lang]}?faqCategoryId=${FAQ_CATEGORY_ID}`);
    return navigate(`/${lang}/${Object.values(RUTAS_GENERALES_MUL2)[index][lang]}`);
  };

  const handleClickLogoNavBar = () => {
    dispatch(resetSegments());
    navigate(`${currentLanguage}/${RUTAS_GENERALES_MUL2.home[currentLanguage]}`);
    dispatch(updateShowSubMenu(false));
  };

  const getNavBarData = async (lang, changed?) => {
    await GetRoutes({ language: lang, type: MENU_TYPE })
      .then((data) => {
        dispatch(updateRoutes(data.data));
        if (changed) {
          const newRoutes = obtenerUrlsValidas(
            data.data.map((el) => {
              return el.child;
            }),
          );
          let newRoute = newRoutes.find((el) => el.pageId === changed);
          if (newRoute !== undefined) {
            navigate(`/${lang}${newRoute.url}`);
            return;
          }
        }
      })
      .finally(() => dispatch(updateShowLoading(false)));
  };

  const handleMenuClick = (route) => {
    dispatch(updateSubMenuIndex(0));
    if(route?.child[0]?.pagePublicCode) return navigate(`${currentLanguage}${route?.url?.toLowerCase()}?pageId=${route?.child[0]?.pagePublicCode}`);
    if(route?.child[0]?.pageId) return navigate(`/${currentLanguage}${route?.url?.toLowerCase()}?pageId=${route?.child[0]?.pageId}`);
    if(route?.child[0]?.url) return navigate(currentLanguage + route?.child[0]?.url?.toLowerCase());
    return navigate(route?.url ? currentLanguage + route?.url?.toLowerCase() : '');
  };

  useEffect(() => {
    getNavBarData(currentLanguage);
    return () => {
      //Habilitamos el Submenu
      dispatch(updateShowSubMenu(false));
    };
  }, [currentLanguage]);

  return routesSelector && routesSelector.length ? (
    <>
      <nav
        className='navBar'
        style={{
          background: theme.colors.navBackground,
          border: `solid 1px ${theme.colors.navBackground}`,
        }}
      >
        <div className='navBar_logo' onClick={() => handleClickLogoNavBar()}>
          <SvgIcon Icon={LogoNavbar} className='navbar-logo-svg' />
        </div>
        <div className='navBar_options'>
          {routesSelector.map((route, index) =>
            route.name === 'separator' ? (
              <div key={index} className='navBar_optionsDivider' />
            ) : (
              <div
                key={route.name + route.pageId + index}
                className={`navBar_optionsItem ${
                  route?.url ? (CURRENT_ROUTE === route?.url ? '--selected' : '') : ''
                }`}
              >
                <div onClick={() => handleMenuClick(route)} style={{ textDecoration: 'none' }}>
                  {route.name}
                </div>
              </div>
            ),
          )}
        </div>

        {/* NAVBAR RIGHT */}
        <div className='navBar_actions'>
          {/* LANGUAGE SELECTOR */}
          <Dropdown
            onChange={(lang) => handleLangChange(lang)}
            items={languageOptions}
            value={selectedLanguage}
            text={t(`lb_${selectedLanguage}`)}
            className='lang-selector'
          />
        </div>
      </nav>
      {showLoginModal && (
        <ModalSignIn
          onClose={() => setShowLoginModal(false)}
          onAceptar={() => setShowLoginModal(false)}
        />
      )}
      {loginOut && (
        <ModalInfoSuccess
          title={t('lb_configuracion_cerrar_sesion')}
          text={t('lb_configuracion_punto_cerrar_sesion')}
          onClose={() => setLoginOut(false)}
          onAccept={() => {
            setLoginOut(false);
            logout();
          }}
          textAccept={t('lb_aceptar')}
          textClose={t('lb_cancelar')}
        />
      )}
    </>
  ) : (
    <></>
  );
});

export default NavBar;
